import { render } from "./CardStars.vue?vue&type=template&id=86bed66a&scoped=true"
import script from "./CardStars.vue?vue&type=script&lang=js"
export * from "./CardStars.vue?vue&type=script&lang=js"

import "./CardStars.vue?vue&type=style&index=0&id=86bed66a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-86bed66a"

export default script